import {CMS_COMPONENT_SOURCE_TYPES} from './homePageComponentsConstants';
import {WEBP_URL_SUFFIX} from '../../components/HbImage/imageConstants';

function cmsComponentsGroupByDataSource(components) {
  return components?.reduce((allComponents, current) => {
    if (
      current?.dataSource === CMS_COMPONENT_SOURCE_TYPES.VOLTRAN &&
      (!current?.url || !current?.clientUrl)
    ) {
      return allComponents
    }

    allComponents?.[current.dataSource]?.push(current);
    return allComponents;
  }, {[CMS_COMPONENT_SOURCE_TYPES.CMS]: [], [CMS_COMPONENT_SOURCE_TYPES.VOLTRAN]: []});
}

function prepareHomepageComponentsWithBannerList(recommendationBannerResponse, cmsBulkListData, homepageComponents) {
  const bannerListFromComponents = []
  const recommendationBanner = recommendationBannerResponse?.data?.bannerMainGroups

  recommendationBanner?.forEach((item) => {
    item?.bannerGroups?.forEach((data) => {
      bannerListFromComponents.push(data)
    })
  })

  cmsBulkListData?.forEach((item) => {
    if (!bannerListFromComponents?.find(banner => banner.typeId.toString() === item.typeId.toString())) {
      bannerListFromComponents.push({
        typeId: item.typeId.toString(),
        bannerList: item?.bannerList,
      })
    }
  })

  const homepageComponentsWithBannerList = homepageComponents?.map((cmsItem) => {
    if (cmsItem?.dataSource === CMS_COMPONENT_SOURCE_TYPES.CMS) {
      const bannerItem = bannerListFromComponents?.find((item) => item.typeId.toString() === cmsItem.id.toString());
      const cmsBanner = cmsBulkListData?.find((item) => item.typeId.toString() === cmsItem.id.toString());

      if (bannerItem) {
        cmsItem.bannerList = bannerItem?.bannerList;
      }

      if (cmsBanner) {
        cmsItem.itemCount = cmsBanner.itemCount;
      }
    }

    return cmsItem;
  })

  return homepageComponentsWithBannerList;
}

const prepareCmsComponentsImagesToPreloading = (preloadedImage) => {
  if (!preloadedImage) {
    return null
  }

  return {
    webp: `${preloadedImage?.image1x} 1x, ${preloadedImage?.image2x} 2x`,
    default: `${preloadedImage?.image1x?.replace(WEBP_URL_SUFFIX, '')}`
  }
}

const getMobileHomepagePreloadedImage = ({mobileHomepageComponents, cmsComponentsMap}) => {
  const firstServerSideRenderedCarouselComponent = mobileHomepageComponents?.find(
    (component) =>
      component.onlyClientSide === false &&
      component.type === 'Features'
  )
  const preloadedImage = cmsComponentsMap.get(firstServerSideRenderedCarouselComponent?.id)?.preloadBannerImage

  return prepareCmsComponentsImagesToPreloading(preloadedImage)
}

const convertPriceToDecimal = (
  value,
  locale = 'tr',
  minimumFractionDigits = 2,
  maximumFractionDigits = 2
) => {
  return Number(value).toLocaleString('tr', {
    minimumFractionDigits,
    maximumFractionDigits,
  });
};


export {
  cmsComponentsGroupByDataSource,
  prepareHomepageComponentsWithBannerList,
  getMobileHomepagePreloadedImage,
  convertPriceToDecimal,
}
